import React from 'react';

export type FilterCollapsibleVariant = 'section' | 'group';

export interface FilterCollapsibleSectionProps {
  title: React.ReactNode;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  sectionId: string;
  /** @deprecated Use variant="group" instead. */
  compact?: boolean;
  variant?: FilterCollapsibleVariant;
}

export default function FilterCollapsibleSection({
  title,
  open,
  onToggle,
  children,
  sectionId,
  compact = false,
  variant,
}: FilterCollapsibleSectionProps) {
  const panelId = `${sectionId}-panel`;
  const resolvedVariant: FilterCollapsibleVariant = variant ?? (compact ? 'group' : 'section');
  const isGroup = resolvedVariant === 'group';

  return (
    <section className={isGroup ? 'sb-filter-group' : 'sb-filter-section'}>
      <button
        type="button"
        className={isGroup ? 'sb-filter-group__toggle' : 'sb-filter-section__toggle'}
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span className={isGroup ? 'sb-filter-group__title' : 'sb-filter-section__title'}>{title}</span>
        <i
          className={`fas fa-chevron-down ${isGroup ? 'sb-filter-group__chevron' : 'sb-filter-section__chevron'}${open ? (isGroup ? ' sb-filter-group__chevron--open' : ' sb-filter-section__chevron--open') : ''}`}
          aria-hidden
        />
      </button>
      <div
        id={panelId}
        className={`${isGroup ? 'sb-filter-group__panel' : 'sb-filter-section__panel'}${open ? (isGroup ? ' sb-filter-group__panel--open' : ' sb-filter-section__panel--open') : ''}`}
      >
        <div className={isGroup ? 'sb-filter-group__panel-inner' : 'sb-filter-section__panel-inner'}>
          {open ? children : null}
        </div>
      </div>
    </section>
  );
}
